import { combineReducers } from 'redux';
import { actions as Actions } from '../utils/constants';

import AppReducer from '../components/app/app.reducer';
import login from '../components/login/login.reducer';
import notifications from '../components/notifications/notifications.reducer';

const appReducer = combineReducers({
    App: AppReducer,
    login,
    notifications,
});

const rootReducer = (state, action) => {
    if (action.type && action.type === Actions.RESTORE_ALL_REDUCERS ) {
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/utils/root-reducer.js